import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LxlibThemeModule } from '@lxlib/theme';

import { DownFileDirective } from './down-file.directive';

const DIRECTIVES = [DownFileDirective];

@NgModule({
  imports: [CommonModule, LxlibThemeModule],
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class DownFileModule {}
